import FaqPage from "@/pages/landing/Faq";
import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(landing)/faq")({
  component: () => (
    <Box
      maxWidth={{
        xs: "640px",
        sm: "768px",
        md: "1024px",
        lg: "1280px",
        xl: "1536px",
      }}
      width={"100%"}
      mx={"auto"}
    >
      <FaqPage />
    </Box>
  ),
});
